import {
  BrandDeepDiveChartResp,
  BrandDeepDiveChartRespDataLookup,
  BrandDependencyCategory,
  BrandDependencyKpi,
  BrandDependencySort,
} from '@models/BrandDependency';
import {
  getBrandDependencyKpiCategory,
  mapBrandDependencyData,
  sortBrandDependencyData,
} from '@data-visualization/brand-dependency-chart/BrandDependencyChartUtils';
import { Filters, Option } from '@utils/pageConfig/Types';
import { getDisplayValue } from '@utils/filterTrayUtils/FilterTrayUtils';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreatorsSideFilters } from '@state/Index';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { useMemo } from 'react';

const MAX_BRANDS_FILTER = 10;

export const getSortedDeepDiveBrands = (
  deepDiveChartData: BrandDeepDiveChartResp,
  deepDiveDataLookup: BrandDeepDiveChartRespDataLookup,
  kpi: BrandDependencyKpi,
  sortBy: BrandDependencySort,
) => {
  const unsortedDeepDiveBrands = deepDiveChartData?.[kpi] ?? [];
  const isDeepDiveView = true;

  const category: BrandDependencyCategory = getBrandDependencyKpiCategory(kpi);

  return unsortedDeepDiveBrands
    .map((brand) => deepDiveDataLookup?.get(brand)!)
    .filter(Boolean)
    .map(mapBrandDependencyData)
    .sort((data1, data2) => sortBrandDependencyData(data1, data2, sortBy, category, isDeepDiveView))
    .map((deepDiveBrandData) => deepDiveBrandData.brand!);
};

export function useBrandsInFilter(brandFilters: Filters): Option[] {
  const dispatch = useDispatch();
  const { updateSideFilters } = bindActionCreators(actionCreatorsSideFilters, dispatch);

  const pagesConfig = usePageConfig();

  return useMemo(
    () => getDisplayValue(pagesConfig, updateSideFilters, pagesConfig.pageType, brandFilters, brandFilters?.options),
    [pagesConfig, updateSideFilters, brandFilters],
  );
}

export function useFilteredBrands(brandFilters: Filters): Option[] {
  const all = useBrandsInFilter(brandFilters);
  return useMemo(() => (all.length > MAX_BRANDS_FILTER ? [] : all), [all]);
}
